import { Platform } from 'react-native';
import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  path?: string;
}

const BASE_URL = 'https://www.hekaya.ma';

export function SEOHead({ title, description, path }: SEOHeadProps) {
  useEffect(() => {
    if (Platform.OS !== 'web') return;

    document.title = title;

    const setMeta = (attr: string, value: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${value}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, value);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);

    if (path !== undefined) {
      const url = `${BASE_URL}${path}`;
      setMeta('property', 'og:url', url);

      let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', url);
    }
  }, [title, description, path]);

  return null;
}
